import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cd2f47c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "구분"),
    /*#__PURE__*/_createElementVNode("th", null, "기본급"),
    /*#__PURE__*/_createElementVNode("th", null, "직무급"),
    /*#__PURE__*/_createElementVNode("th", null, "직책수당"),
    /*#__PURE__*/_createElementVNode("th", null, "근속수당"),
    /*#__PURE__*/_createElementVNode("th", null, "식대"),
    /*#__PURE__*/_createElementVNode("th", null, "교통비"),
    /*#__PURE__*/_createElementVNode("th", null, "총액")
  ])
], -1))

import { ref } from 'vue';
import { WageCompareItem } from '../../../types/wage';


export default /*#__PURE__*/_defineComponent({
  __name: 'WageCompareAfter',
  setup(__props) {

const wageItems = ref<WageCompareItem[]>([
  {
    category: '변경',
    basicPay: 0,
    jobPay: 0,
    positionAllowance: 0,
    seniorityAllowance: 0,
    mealAllowance: 0,
    transportationAllowance: 0,
    total: 0
  }
]);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mb-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "fontNotoSans700" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [
              _createTextVNode("mdi-arrow-right")
            ]),
            _: 1
          }),
          _createTextVNode(" 서비스 적용 후 ")
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wageItems.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.category), 1),
                    _createElementVNode("td", null, _toDisplayString(item.basicPay), 1),
                    _createElementVNode("td", null, _toDisplayString(item.jobPay), 1),
                    _createElementVNode("td", null, _toDisplayString(item.positionAllowance), 1),
                    _createElementVNode("td", null, _toDisplayString(item.seniorityAllowance), 1),
                    _createElementVNode("td", null, _toDisplayString(item.mealAllowance), 1),
                    _createElementVNode("td", null, _toDisplayString(item.transportationAllowance), 1),
                    _createElementVNode("td", null, _toDisplayString(item.total), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})